import styled from 'styled-components';
import { color } from '../templates/Ui';
const Paragraph = styled.p `
    color: ${color.text.base};
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 15px;
`;
export default Paragraph;
